<template>
  <div id="loadingSreen">
    <div id="loader">

    </div>
    <div id="loaderShadow">

    </div>
  </div>
</template>

<script>
import Loader from '../utils/Loader.js'

export default {
  name: "Loader",
  mounted(){
    const laoder = new Loader()
    laoder.udpateHtmlElements()
  }
}
</script>

<style scoped>
#loadingSreen
{
  z-index: 2;
  position: absolute;
  top: 0;
}
#loadingSreen *
{
  width: 100vw;
  height: 100vh;
  position: absolute;
}
#loader
{
  z-index: 2;
  background-color: #f5f5f5;
}
#loaderShadow
{
  background-color: #111111;
}
</style>